import React from "react";
import style from "./CardFormKyc.module.scss";
import { Col, Row, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { useCallback, useEffect, useMemo, useState } from "react";
import InputFormik from "../../../../../../common/Formik/Input/InputFormik";
import CommonDatePicker from "../../../../../../common/Formik/DatePiker/DatePicker";
import Select from "../../../../../../common/Formik/Select/Select";
import Button from "../../../../../../common/Button/Button";
import csc from "country-state-city";
import {
  getOccupationCodesAction,
  getUserInfoAction,
  initiateApplicationAction,
} from "../../../../../../../features/user/userSlice";
import { useDispatch } from "react-redux";
import { validationMessage } from "../../../../../../../Helper/helperfunction";
import {
  ALLOWED_ISO_CODES,
  APPLY_CARD_SHIPPING_PREFILL_KEY,
  COUNTRY_OF_ISSUE_OPTIONS,
  FORMIK_REGEX,
  Messages,
  STATUS_CODE,
  countryByIso,
  getKycCountryIsoFromUserProfileCountry,
  getPhoneCodeByCountryIso,
} from "../../../../../../../utils/constants";
import { ROUTES } from "../../../../../../../routes";
import { publicIpv4 } from "public-ip";
import { getOS } from "../../../../../../../utils/utils";

const isApplicationApproved = (status) => {
  if (status == null || typeof status !== "string") return false;
  const s = status.trim().toLowerCase();
  return s === "approved" || s === "approve";
};

const CardFormKyc = ({ onSubmit, onApplicationApproved }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [ipAddress, setIpAddress] = useState("0.0.0.0");
  const [occupationOptions, setOccupationOptions] = useState([]);
  const [userData, setUserData] = useState(null);

  // Regions/states for the selected country (country-state-city)
  const updatedStates = (countryId) =>
    csc.getStatesOfCountry(countryId).map((state) => ({
      label: state.name,
      value: state.id,
      ...state,
    }));

  // ✅ VALIDATION (SAME STYLE AS EditProfile)
  const validationSchema = Yup.object({
    firstName: Yup.string()
      .trim()
      .min(3, "First Name must be at least 3 characters")
      .max(50, "First Name must be at most 50 characters")
      .required(validationMessage("First Name"))
      .matches(FORMIK_REGEX.ALPHA, Messages.ALPHABETSVALIDATION),

    lastName: Yup.string()
      .trim()
      .min(3, "Last Name must be at least 3 characters")
      .max(50, "Last Name must be at most 50 characters")
      .required(validationMessage("Last Name"))
      .matches(FORMIK_REGEX.ALPHA, Messages.ALPHABETSVALIDATION),

    date: Yup.date()
      .typeError("Invalid Birth Date")
      .nullable()
      .required(validationMessage("Birth Date"))
      .max(new Date(), "Birth Date cannot be in the future"),

    countryOfIssue: Yup.string()
      .required(validationMessage("Country of Issue"))
      .oneOf(ALLOWED_ISO_CODES, "This country is not available"),
   nationalId: Yup.string()
  .required(validationMessage("National ID"))
  .min(5, "National ID must be at least 5 characters")
  .max(30, "National ID must not exceed 30 characters")
        .matches(/^\S.*$/, "National ID  must not start with a space") .matches(/.*\S$/, "National ID  must not end with a space")

  .matches(
  /^[A-Za-z0-9](?:[A-Za-z0-9 -]*[A-Za-z0-9])?$/,
  "National ID can contain only letters, numbers, spaces and hyphens"
),

    // nationalId: Yup.string()
    //   .trim()
    //   .min(4, "National ID must be at least 4 characters")
    //   .max(30, "National ID must be at most 30 characters")
    //   .matches(
    //     /^[A-Za-z0-9\- ]+$/,
    //     "National ID can contain only letters, numbers, spaces, and hyphens"
    //   )
    //   .required(validationMessage("National ID")),

    phoneNumber: Yup.string()
      .required(validationMessage("Phone Number"))
.matches(/^[0-9\s()-]+$/, Messages.NUMBERVALIDATION)
      .min(6, "Phone Number must be at least 6 digits")
      .max(15, "Phone Number must be at most 15 digits"),

    // phoneCountryCode: Yup.object()
    //   .nullable()
    //   .required(validationMessage('Phone Country Code'))
    //   .shape({
    //     value: Yup.string()
    //       .matches(/^[0-9]{1,3}$/, 'Invalid country code')
    //       .required(),
    //     label: Yup.string().required(),
    //   }),
    phoneCountryCode: Yup.string().required(
      validationMessage("Phone Country Code"),
    ),

    address: Yup.string()
      .trim()
      .min(4, "Address must be at least 4 characters")
      .max(200, "Address must be at most 200 characters")
      .required(validationMessage("Address")),

    city: Yup.string()
      .trim()
      .max(60, "City must be at most 60 characters")
      .required(validationMessage("City"))
      .matches(FORMIK_REGEX.ALPHASPACE, Messages.ALPHABETSVALIDATION),

    region: Yup.object().nullable().required(validationMessage("Region")),

    postalCode: Yup.string()
      .required(validationMessage("Postal Code"))
      .matches(/^\S.*$/, "Postal Code must not start with a space") .matches(/.*\S$/, "Postal Code must not end with a space")
.matches(
  /^(?=.*[A-Za-z0-9])[A-Za-z0-9]+(?:[ -][A-Za-z0-9]+)*$/,
  "Please enter a valid postal code"
)   .min(4, "Postal Code must be at least 4 characters")
      .max(20, "Postal Code must be at most 20 characters"),

    countryCode: Yup.string()
      .required(validationMessage("Country Code"))
      .oneOf(ALLOWED_ISO_CODES, "This country is not available"),

    occupation: Yup.object()
      .nullable()
      .required(validationMessage("Occupation")),
      // .shape({
      //   value: Yup.string()
      //     .required(validationMessage("Occupation"))
      //     .matches(FORMIK_REGEX.ALPHASPACE, Messages.ALPHABETSVALIDATION),
      //   label: Yup.string().required(),
      // }),

    annualSalary: Yup.number()
      .typeError("Annual Salary must be a number")
      .min(0, "Annual Salary cannot be negative")
      .max(1000000000, "Annual Salary seems too high")
      .required(validationMessage("Annual Salary")),

    accountPurpose: Yup.string()
      .trim()
      .min(4, "Account Purpose must be at least 4 characters")
      .max(200, "Account Purpose must be at most 200 characters")
     .matches(/^[A-Za-z,\-\s]+$/, Messages.ALPHABETSVALIDATION)
      .required(validationMessage("Account Purpose")),

    expectedMonthlyVolume: Yup.number()
      .typeError("Expected Monthly Volume must be a number")
      .min(1, "Expected Monthly Volume must be greater than 0")
      .required(validationMessage("Expected Monthly Volume")),

    acceptEsignConsent: Yup.boolean().oneOf(
      [true],
      "You must accept the E-Sign Consent",
    ),
    acceptStblCardTermsAndIssuerPrivacy: Yup.boolean().oneOf(
      [true],
      "You must accept the STBL Card Terms and the Issuer Privacy Policy",
    ),
    certifyInformationAndRules: Yup.boolean().oneOf(
      [true],
      "You must certify that your information is accurate and that you will abide by the card rules",
    ),
    acknowledgeNoUnauthorizedSolicitation: Yup.boolean().oneOf(
      [true],
      "You must acknowledge that this application does not constitute unauthorized solicitation",
    ),
    acceptAccountOpeningPrivacyNotice: Yup.boolean().when("countryOfIssue", {
      is: "US",
      then: (schema) =>
        schema.oneOf(
          [true],
          "You must accept the Account Opening Privacy Notice",
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  // const handleFormSubmit = async (values) => {
  //   setLoading(true);
  //   try {
  //     const payload = {
  //       firstName: values.firstName,
  //       lastName: values.lastName,
  //       birthDate: values.date
  //         ? new Date(values.date).toISOString().split("T")[0]
  //         : "",

  //       nationalId: values.nationalId,
  //       countryOfIssue: "US", // ✅ Hardcoded US
  //       phoneNumber: values.phoneNumber,
  //       phoneCountryCode: "1", // ✅ Hardcoded US
  //       address: {
  //         line1: values.address,
  //         city: values.city,
  //         region: values.region?.label || "",
  //         postalCode: values.postalCode,
  //         countryCode: "US", // ✅ Hardcoded US
  //       },
  //       occupation: values.occupation?.value,
  //       accountPurpose: values.accountPurpose,
  //       expectedMonthlyVolume: values.expectedMonthlyVolume,
  //       annualSalary: values.annualSalary,
  //       ipAddress: ipAddress || "0.0.0.0",
  //       isTermsOfServiceAccepted: values.termsAccepted,
  //       sourceKey: getOS() || ""
  //     };

  //     console.log("Submitting payload:", payload);

  //     const response = await dispatch(initiateApplicationAction(payload));

  //     if (response?.status === 200) {
  //       setLoading(false);
  //       const link = response?.data?.data?.applicationCompletionLink;

  //       if (link?.url && link?.params?.userId && link?.params?.signature) {
  //         const redirectUrl =
  //           `${link.url}?userId=${link.params.userId}` +
  //           `&signature=${link.params.signature}` +
  //           `&redirect=${window.location.origin}/auth/apply-card`;
  //         onSubmit(redirectUrl);
  //       }
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Form submission error:", error);
  //   }
  // };
  const handleFormSubmit = async (values) => {
    setLoading(true);

    try {
      const payload = {
        firstName: values.firstName,
        lastName: values.lastName,
        birthDate: values.date
          ? new Date(values.date).toISOString().split("T")[0]
          : "",
        nationalId: values.nationalId,
        countryOfIssue: values.countryOfIssue,
        phoneNumber: values.phoneNumber,
        phoneCountryCode: values.phoneCountryCode,
        address: {
          line1: values.address,
          city: values.city,
          region: values.region?.label || "",
          postalCode: values.postalCode,
          countryCode: values.countryCode,
        },
        occupation: values.occupation?.value,
        accountPurpose: values.accountPurpose,
        expectedMonthlyVolume: values.expectedMonthlyVolume,
        annualSalary: values.annualSalary,
        ipAddress: ipAddress || "0.0.0.0",
        isTermsOfServiceAccepted: values.acceptEsignConsent,
        // values.acceptStblCardTermsAndIssuerPrivacy &&
        // values.certifyInformationAndRules &&
        // values.acknowledgeNoUnauthorizedSolicitation,
        sourceKey: getOS() || "",
      };

      const response = await dispatch(initiateApplicationAction(payload));

      if (response?.status === STATUS_CODE.successful) {
        const responseData = response?.data?.data ?? response?.data;
        const applicationStatus = responseData?.applicationStatus;

        try {
          sessionStorage.setItem(
            APPLY_CARD_SHIPPING_PREFILL_KEY,
            JSON.stringify({
              address: values.address,
              city: values.city,
              postalCode: values.postalCode,
              countryCode: values.countryCode,
              countryOfIssue: values.countryOfIssue,
              phoneCountryCode: values.phoneCountryCode,
              phoneNumber: values.phoneNumber,
              regionValue: values.region?.value ?? null,
            }),
          );
        } catch {
          /* storage unavailable */
        }

        if (isApplicationApproved(applicationStatus)) {
          onApplicationApproved?.();
          return;
        }

        // Other statuses: KYC completion link flow
        const link = responseData?.applicationCompletionLink;

        if (link?.url && link?.params?.userId && link?.params?.signature) {
          const redirectUrl =
            `${link.url}?userId=${link.params.userId}` +
            `&signature=${encodeURIComponent(link.params.signature)}` +
            `&redirect=${encodeURIComponent(
              `${window.location.origin}/auth/apply-card?kycStatus=pending`
            )}`;

          // 👉 direct redirect (recommended)
          window.location.href = redirectUrl;

          // ❌ agar parent use karna hai to ye use karo:
          // onSubmit(redirectUrl);
        } else {
          console.error("KYC link missing in response");
        }
      } else {
        console.error("API failed:", response);
      }
    } catch (error) {
      console.error("Form submission error:", error);
    } finally {
      setLoading(false);
    }
  };

  const getUserProfile = useCallback(async () => {
    try {
      const response = await dispatch(getUserInfoAction());
      if (response?.data?.data) {
        setUserData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  }, [dispatch]);

  const getOccupationOptions = useCallback(async () => {
    try {
      const res = await dispatch(getOccupationCodesAction());
      if (res?.data?.status === STATUS_CODE.successful) {
        const options =
          res?.data?.data?.map((options) => ({
            value: options.description,
            label: options.description,
          })) || [];
        setOccupationOptions(options);
      }
    } catch (error) {
      console.log(error, "error");
    }
  }, [dispatch]);

  const ipGet = async () => {
    let data = await publicIpv4();
    setIpAddress(data);
  };

  useEffect(() => {
    ipGet();
    getOccupationOptions();
    getUserProfile();
  }, [getOccupationOptions, getUserProfile]);

  /** ISO2 from profile (API may send "IT" or "Italy"); labels from COUNTRY_OF_ISSUE_OPTIONS. */
  const profileCountryIso = useMemo(
    () => getKycCountryIsoFromUserProfileCountry(userData?.country),
    [userData?.country],
  );

  const formInitialValues = useMemo(
    () => ({
      firstName: "",
      lastName: "",
      date: null,
      nationalId: "",
      phoneNumber: "",
      address: "",
      city: "",
      region: null,
      postalCode: "",
      countryCode: profileCountryIso,
      occupation: "",
      annualSalary: "",
      phoneCountryCode: getPhoneCodeByCountryIso(profileCountryIso),
      accountPurpose: "",
      expectedMonthlyVolume: "",
      countryOfIssue: profileCountryIso,
      acceptEsignConsent: false,
      acceptStblCardTermsAndIssuerPrivacy: false,
      certifyInformationAndRules: false,
      acknowledgeNoUnauthorizedSolicitation: false,
      acceptAccountOpeningPrivacyNotice: false,
    }),
    [profileCountryIso],
  );

  return (
    <>
      <div className={style.cardFormKyc}>
        <Formik
          enableReinitialize
          initialValues={formInitialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => handleFormSubmit(values)}
        >
          {(formik) => {
            const selectedCountry = countryByIso(formik.values.countryOfIssue);
            const regionOptions = selectedCountry
              ? updatedStates(selectedCountry.id)
              : [];

            return (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <div className={style.infoCards}>
                  <h4>Personal Information</h4>
                  <div className={style.infoCards_innerform}>
                    <Row>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="firstName"
                          label="First Name"
                          placeholder="Enter First Name"
                          className="fieldinput"
                          {...formik.getFieldProps("firstName")}
                          formik={formik}
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="lastName"
                          label="Last Name"
                          placeholder="Enter Last Name"
                          className="fieldinput"
                          {...formik.getFieldProps("lastName")}
                          formik={formik}
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <CommonDatePicker
                          className="fielddate"
                          variant="large_height"
                          label="Birth Date"
                          name="date"
                          value={formik.values.date}
                          placeholder="Enter Birth Date"
                          onChange={(date) =>
                            formik.setFieldValue("date", date)
                          }
                          onBlur={formik.handleBlur}
                          formik={formik}
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <Select
                          variant="xlarge_height"
                          className="select_time"
                          label="Country of Issue"
                          name="countryOfIssue"
                          placeholder={<h6>Select country</h6>}
                          options={COUNTRY_OF_ISSUE_OPTIONS}
                          value={
                            COUNTRY_OF_ISSUE_OPTIONS.find(
                              (o) => o.value === formik.values.countryOfIssue,
                            ) || null
                          }
                          onChange={(opt) => {
                            if (!opt) return;
                            formik.setFieldValue("countryOfIssue", opt.value);
                            formik.setFieldValue("countryCode", opt.value);
                            formik.setFieldValue(
                              "phoneCountryCode",
                              getPhoneCodeByCountryIso(opt.value),
                            );
                            formik.setFieldValue("region", null);
                          }}
                          isSearchable={true}
                          formik={formik}
                        />
                      </Col>

                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="xlarge_height"
                          className="select_time"
                          label="National ID"
                          name="nationalId"
                          placeholder="Enter National ID"
                          value={formik.values.nationalId}
                          onChange={(e) => {
  const value = e.target.value;

  if (value.length <= 30) {
    formik.setFieldValue("nationalId", value);
  }
}}
                          onBlur={formik.handleBlur}
                          formik={formik}
                        />
                      </Col>

                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="phoneNumber"
                          label="Phone Number"
                          placeholder="Enter Phone Number"
                          className="fieldinput"
                          {...formik.getFieldProps("phoneNumber")}
                          formik={formik}
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="phoneCountryCode"
                          label="Phone Country Code"
                          placeholder="e.g. 1"
                          className="fieldinput"
                          {...formik.getFieldProps("phoneCountryCode")}
                          disabled
                          formik={formik}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className={style.infoCards}>
                  <h4>Address Details</h4>
                  <div className={style.infoCards_innerform}>
                    <Row>
                      <Col xxl={6} xl={6} lg={6} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="address"
                          label="Street Address (House No., Building, Street, Landmark)"
                          placeholder="Enter Address"
                          className="fieldinput"
                          {...formik.getFieldProps("address")}
                          formik={formik}
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <Select
                          variant="xlarge_height"
                          className="select_time"
                          label="Region"
                          name="region"
                          placeholder={<h6>Select Region</h6>}
                          options={regionOptions}
                          value={formik.values.region}
                          onChange={(value) =>
                            formik.setFieldValue("region", value)
                          }
                          isSearchable={true}
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="city"
                          label="City"
                          placeholder="Enter City"
                          className="fieldinput"
                          {...formik.getFieldProps("city")}
                          formik={formik}
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="postalCode"
                          label="Postal Code"
                          placeholder="Enter Postal Code"
                          className="fieldinput"
                          {...formik.getFieldProps("postalCode")}
                          formik={formik}
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="countryCode"
                          label="Country Code"
                          placeholder="US"
                          className="fieldinput"
                          value={formik.values.countryCode}
                          onChange={(e) => {
                            const raw = e.target.value
                              .toUpperCase()
                              .replace(/[^A-Z]/g, "")
                              .slice(0, 2);
                            formik.setFieldValue("countryCode", raw);
                            if (raw.length === 2) {
                              const c = countryByIso(raw);
                              if (c) {
                                formik.setFieldValue(
                                  "countryOfIssue",
                                  c.sortname.toUpperCase(),
                                );
                                formik.setFieldValue(
                                  "phoneCountryCode",
                                  getPhoneCodeByCountryIso(raw),
                                );
                                formik.setFieldValue("region", null);
                              }
                            }
                          }}
                          onBlur={formik.handleBlur}
                          disabled
                          formik={formik}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className={style.infoCards}>
                  <h4>Other Details</h4>
                  <div className={style.infoCards_innerform}>
                    <Row>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        {/* <InputFormik
                        variant="large_height"
                        name="occupation"
                        label="Occupation"
                        placeholder="Enter Occupation"
                        className="fieldinput"
                        {...formik.getFieldProps("occupation")}
                        formik={formik}
                      /> */}
                        <Select
                          variant="xlarge_height"
                          className="select_time"
                          label="Occupation"
                          name="occupation"
                          placeholder={<h6>Select Occupation</h6>}
                          options={occupationOptions}
                          value={formik.values.occupation}
                          onChange={(value) =>
                            formik.setFieldValue("occupation", value)
                          }
                          isSearchable={true}
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="annualSalary"
                          label="Annual Salary [USD]"
                          placeholder="Enter Annual Salary"
                          className="fieldinput"
                          {...formik.getFieldProps("annualSalary")}
                          formik={formik}
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="accountPurpose"
                          label="Account Purpose"
                          placeholder="Enter Account Purpose"
                          {...formik.getFieldProps("accountPurpose")}
                          onChange={(e) => {
                            formik.handleChange(e);
                            formik.setFieldTouched(
                              "accountPurpose",
                              true,
                              true,
                            );
                          }}
                          formik={formik}
                        />
                      </Col>
                      {/* <Col xxl={3} xl={3} lg={4} md={6}>
                      <InputFormik
                        variant="large_height"
                        name="walletAddress"
                        label="Wallet Address"
                        placeholder="Enter Wallet Address"
                        className="fieldinput"
                        {...formik.getFieldProps("walletAddress")}
                        formik={formik}
                      />
                    </Col> */}
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="expectedMonthlyVolume"
                          label="Expected Monthly Volume [USDT]"
                          placeholder="Enter Expected Monthly Volume"
                          {...formik.getFieldProps("expectedMonthlyVolume")}
                          formik={formik}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className={style.consentOutside}>
                    <label className={style.consentLabel}>
                      <input
                        type="checkbox"
                        name="acceptEsignConsent"
                        checked={formik.values.acceptEsignConsent}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      <span>
                        {" "}
                        I accept the{" "}
                        <a
                          href={ROUTES.THIRD_PARTY_ESIGN_CONSENT}
                          target="_blank"
                          rel="noreferrer"
                        >
                          E-Sign Consent
                        </a>
                      </span>
                    </label>
                    {formik.touched.acceptEsignConsent &&
                      formik.errors.acceptEsignConsent && (
                        <div className={style.consentError}>
                          {formik.errors.acceptEsignConsent}
                        </div>
                      )}


                    {formik.values.countryOfIssue === "US" && (
                      <>
                        <label className={style.consentLabel}>
                          <input
                            type="checkbox"
                            name="acceptAccountOpeningPrivacyNotice"
                            checked={
                              formik.values.acceptAccountOpeningPrivacyNotice
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <span>
                            {" "}
                            I accept the{" "}
                            <a
                              href={
                                ROUTES.THIRD_PARTY_ACCOUNT_OPENING_PRIVACY_NOTICE
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              Account Opening Privacy Notice
                            </a>
                          </span>
                        </label>
                        {formik.touched.acceptAccountOpeningPrivacyNotice &&
                          formik.errors.acceptAccountOpeningPrivacyNotice && (
                            <div className={style.consentError}>
                              {formik.errors.acceptAccountOpeningPrivacyNotice}
                            </div>
                          )}
                      </>
                    )}

                    <label className={style.consentLabel}>
                      <input
                        type="checkbox"
                        name="acceptStblCardTermsAndIssuerPrivacy"
                        checked={
                          formik.values.acceptStblCardTermsAndIssuerPrivacy
                        }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      <span>
                        {" "}
                        I accept the{" "}
                        <a
                          href={
                            formik.values.countryOfIssue === "US"
                              ? ROUTES.CARD_TERMS_US
                              : ROUTES.CARD_TERMS_INTERNATIONAL
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          STBL Card Terms
                        </a>
                        , and the{" "}
                        <a
                          href="https://www.third-national.com/privacypolicy"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Issuer Privacy Policy
                        </a>
                      </span>
                    </label>
                    {formik.touched.acceptStblCardTermsAndIssuerPrivacy &&
                      formik.errors.acceptStblCardTermsAndIssuerPrivacy && (
                        <div className={style.consentError}>
                          {formik.errors.acceptStblCardTermsAndIssuerPrivacy}
                        </div>
                      )}

                    <label className={style.consentLabel}>
                      <input
                        type="checkbox"
                        name="certifyInformationAndRules"
                        checked={formik.values.certifyInformationAndRules}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      <span>
                        {" "}
                        I certify that the information I have provided is
                        accurate and that I will abide by all the rules and
                        requirements related to my STBL Spend Card
                      </span>
                    </label>
                    {formik.touched.certifyInformationAndRules &&
                      formik.errors.certifyInformationAndRules && (
                        <div className={style.consentError}>
                          {formik.errors.certifyInformationAndRules}
                        </div>
                      )}

                    <label className={style.consentLabel}>
                      <input
                        type="checkbox"
                        name="acknowledgeNoUnauthorizedSolicitation"
                        checked={
                          formik.values.acknowledgeNoUnauthorizedSolicitation
                        }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      <span>
                        {" "}
                        I acknowledge that applying for the STBL Spend Card does
                        not constitute unauthorized solicitation
                      </span>
                    </label>
                    {formik.touched.acknowledgeNoUnauthorizedSolicitation &&
                      formik.errors.acknowledgeNoUnauthorizedSolicitation && (
                        <div className={style.consentError}>
                          {formik.errors.acknowledgeNoUnauthorizedSolicitation}
                        </div>
                      )}
                  </div>
                </div>
                {/* <div style={{ color: 'red', margin: '10px 0', fontSize: '13px' }}>
                                {Object.keys(formik.errors).length > 0 && (
                                  <>Form has errors: {JSON.stringify(formik.errors)}</>
                                )}
                                {!formik.isValid && ' → form is invalid'}
                                {formik.isSubmitting && ' → is submitting'}
                              </div> */}
                <Button
                  className={style.btn_Size}
                  type="button"
                  disabled={loading || !formik.isValid}
                  onClick={(e) => {
                    formik.handleSubmit(e);
                  }}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </Button>
              </form>
            );
          }}
        </Formik>
      </div>
    </>
  );
};

export default CardFormKyc;
